//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import 'dayjs/locale/ko';
import useDelete from '../../../../hooks/useDeleteN';
import { useSearch1, useDelete1, useSave1 } from './EMR_BASIC_QUERY';
/** Icons Import */
import EMR_BASIC from './EMR_BASIC';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { useSave } from '../../../../hooks/useSaveN';
import useFileUpload from '../../../../hooks/useFileUpload';
import { EMR_BASIC_Schema } from './EMR_BASIC_Schema';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import { setStartDate, setEndDate } from '../../../../Reducer/SearchReducer';
import dayjs from 'dayjs';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'EmergencyManual';
//#endregion

function EMR_BASICF(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef(); //비상대응매뉴얼 그리드

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  // 검색 조건에서 사용할 시작일/종료일 상태 관리
  const startDate = searchInfo.startDate;
  const endDate = searchInfo.endDate;

  const handleStartDateChange = (newStart) => {
    const newStartDate = dayjs(newStart).format('YYYY-MM-DD');
    let updatedEnd = searchInfo.endDate;

    // 시작일이 종료일보다 크거나 같으면 종료일도 시작일로 맞춤
    if (!dayjs(newStartDate).isBefore(dayjs(updatedEnd))) {
      updatedEnd = newStartDate;
      dispatch(setEndDate(updatedEnd));
    }

    dispatch(setStartDate(newStartDate));
  };

  const handleEndDateChange = (newEnd) => {
    const newEndDate = dayjs(newEnd).format('YYYY-MM-DD');
    let updatedStart = searchInfo.startDate;

    // 종료일이 시작일보다 빠르면 시작일을 종료일로 맞춤
    if (dayjs(newEndDate).isBefore(dayjs(updatedStart))) {
      updatedStart = newEndDate;
      dispatch(setStartDate(updatedStart));
    }

    dispatch(setEndDate(newEndDate));
  };
  //#endregion

  //#region 커스텀훅
  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: () => {
      return `EmergencyManual/${searchInfo.custCd}/EMR_BASIC`;
    },
  });
  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.chaebun,
  });
  //#endregion

  //#region useEffect
  // 버튼 로직
  useEffect(() => {
    if (props.filterClick2) {
      gridRef1.current.api &&
        gridRef1.current.api.setQuickFilter(searchInfo.searchText || '');
      props.setFilterClick2(false);
    }
    if (props.saveClick2) {
      Save1();
      props.setSaveClick2(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.filterClick2, props.saveClick2, searchInfo.searchText]);
  //#endregion

  //#region 쿼리
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });
  const SearchLogic1 = async () => {
    ResetLogic();
    await Search1();
  };

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 저장
  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '파일 업로드',
    schema: EMR_BASIC_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => Save1Async(rows),
    fileSave: SaveLogicFile,
    fileDelete: DeleteLogicFile,
    refresh: () => SearchLogic1(),
    reset: () => ResetLogic(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  // 초기화
  const ResetLogic = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };
  //#endregion

  //#region 나머지 함수
  // 서식 다운로드
  const DownloadLogic1 = async () => {
    try {
      const filePath = 'DocumentForm/비상대응매뉴얼_예시.hwp';
      const fileName = '비상대응매뉴얼_예시.hwp';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 서식 다운로드 완료.`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  // 파일 다운로드
  const DownloadLogic2 = async (_data) => {
    if (_data.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = fixUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  // 새로운 행 에러 메세지 처리
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  //#endregion

  return (
    <div className="wrap">
      <EMR_BASIC
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        rowData1={rowData1}
        lanInfo={lanInfo}
        gridRef1={gridRef1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowNosRef1={selectedRowNosRef1}
        deletedRowData1={deletedRowData1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        searchInfo={searchInfo}
        // 날짜 관련 props
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        // 함수
        ResetLogic1={ResetLogic}
        SearchLogic1={SearchLogic1}
        SaveLogic1={Save1}
        SaveLogicPreview={SaveLogicPreview}
        DownloadLogic1={DownloadLogic1}
        DownloadLogic2={DownloadLogic2}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
      />
    </div>
  );
}

export default EMR_BASICF;
